import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'irb-footer-dialog',
  templateUrl: './footer-dialog.component.html',
  styleUrls: ['./footer-dialog.component.scss']
})
export class FooterDialogComponent implements OnInit {
  now: Date = new Date();
  constructor(public dialogRef: MatDialogRef<FooterDialogComponent>) {}

  ngOnInit() {
  }

  close() {  
    this.dialogRef.close();
  }


}
